// extracted by mini-css-extract-plugin
export default {"iconContainer":"styles-module__iconContainer__src-labstep-web-components-Entity-Template-SectionItem-_CDSoA"};